module.exports = __webpack_public_path__ + "static/img/hotwindImg4.942db3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotwindImg4.png
// module id = 8/xp
// module chunks = 2